import styled from 'styled-components'
import breakpoints from 'utils/consts/breakpoints'
import Images from 'components/Pages/Wine/View/Main/Content/Images'
import AppellationRatings from 'components/Pages/Wine/View/Main/Content/AppellationRatings'
import ColumnLeft from './ColumnLeft'
import ColumnRight from './ColumnRight'
import MainInfo from './MainInfo'
import ProductSpecs from './ProductSpecs'

const Wrapper = styled.div`
  flex: 1;
  max-width: 1168px;
  width: 100%;
  margin: 32px auto;
  padding: 0 24px;
  word-break: break-word;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    margin: 24px 0;
  }

  @media screen and ${breakpoints.device.mobile} {
    padding: 0 16px;
  }

  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
`

const Top = styled.div`
  display: grid;
  grid-template:
    'images main-info' min-content
    'images product-rating' min-content
    'images product-specs' 1fr;
  grid-template-columns: 512px minmax(auto, 544px);
  grid-column-gap: 64px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    grid-template-areas: 'main-info' 'images' 'product-rating' 'product-specs' 'left-column' 'right-column';
    grid-template-columns: 1fr;
    grid-column-gap: 0;
    row-gap: 0;
  }

  & > :not(:last-child) {
    margin-bottom: 32px;
  }
`

const Bottom = styled.div`
  display: grid;
  grid-template-columns: 512px minmax(auto, 544px);
  grid-column-gap: 64px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    grid-template-columns: 1fr;
    grid-column-gap: 0;
    row-gap: 0;
  }
`

const Divider = styled.div`
  height: 1px;
  background: #e7e7ea;
  margin: 32px 0;
  grid-column: span 2;

  @media screen and ${breakpoints.device.laptop},
    ${breakpoints.device.tablet},
    ${breakpoints.device.mobile} {
    display: none;
  }
`

const Content = () => {
  return (
    <Wrapper>
      <Top>
        <Images />
        <MainInfo />
        <AppellationRatings />
        <ProductSpecs />
      </Top>
      <Divider />
      <Bottom>
        <ColumnLeft />
        <ColumnRight />
      </Bottom>
    </Wrapper>
  )
}

export default Content
